import React from 'react';
import {Link} from 'react-router-dom';
import { assetPath, company } from '../../data/companyData';

export default class HeroOne extends React.Component {
    componentDidMount() {

        const $ = window.$;
        
        if ($('.slider-carousel').length) {
            $('.slider-carousel').owlCarousel({
              animateOut: 'fadeOut',
              animateIn: 'fadeIn',
              loop: true,
              margin: 0,
              nav: false,
              singleItem: true,
              smartSpeed: 500,
              autoplay: true,
              autoplayTimeout: 6000,
              navText: ['<span class="icon-right-arrow"></span>', '<span class="icon-right-arrow"></span>'],
              responsive: {
                0: {
                  items: 1
                },
                600: {
                  items: 1
                },
                1024: {
                  items: 1
                }
              }
            });
          }
          
    }
    render(){
        const slides = [
            {
                image: "gallery-01-built-in-media-wall.jpeg",
                kicker: company.tagline,
                title: "Welcome to FA Interior Trim LLC",
                text: "Custom cabinets, interior trim, remodeling, drywall, doors, windows, painting, and roofing with over 20 years of hands-on experience.",
                align: "",
            },
            {
                image: "gallery-08-barn-door.jpeg",
                kicker: "Custom finish carpentry",
                title: "Built-ins, doors, and details made to fit",
                text: "We bring precise craftsmanship and personalized service to residential and commercial spaces.",
                align: "text-center",
            },
            {
                image: "gallery-12-mudroom-bench.jpeg",
                kicker: "Remodeling with care",
                title: "Functional spaces with a polished finish",
                text: "From small upgrades to full remodels, our team keeps the process clear, efficient, and detail focused.",
                align: "",
            },
        ];
        return (
            <>
                <section className="slider-one-sec style3">
                    <div className="slider-carousel owl-carousel owl-theme">
                        {slides.map((slide) => (
                            <div className="slider-one__single" key={slide.image}>
                                <div className="image-layer" style={{backgroundImage: `url(${assetPath(slide.image)})`}}>
                                </div>
                                <div className={slide.align ? "container pl-0" : "container"}>
                                    <div className="row clearfix">
                                        <div className="col-xl-12">
                                            <div className={`slider-one__single-content ${slide.align}`}>
                                                <h3>{slide.kicker}</h3>
                                                <h2>{slide.title}</h2>
                                                <p>{slide.text}</p>
                                                <div className="btn-box">
                                                    <Link to={process.env.PUBLIC_URL + `/contact`} className="thm-btn" data-text="Free Estimate +">Free Estimate +</Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </section>
            </>
        )
    }
}
